import YesIcon from 'assets/images/yes-icon.svg';
import YesIcon2 from 'assets/images/yes-icon-2.svg';
import YesIcon3 from 'assets/images/yes-icon-3.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import LoginLogo from 'assets/images/login-logo.svg';
import PlanCardHeaderLogo1 from 'assets/images/plan-card-header-logo-1.svg';
import PlanCardHeaderLogo2 from 'assets/images/plan-card-header-logo-2.svg';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Lollipop Dental',
  tokenName: 'lollipopdentalSubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  heroLocaleColor: 'secondary',
  splitPlans: true,
  headerProps: {
    enable: true,
    showLogin: false,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
        variant: 'contained',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img-mobile.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 3,
      alignTitle: 'center',
      alignCard: 'center',
    },
    subscriptionSection: {
      priority: 'top',
      renderAsTabsLimit:4,
      cardVariant: 6,
      tabVariant: 1,
      disableGroupSavings: true,
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'contained',
          normalColor: 'primary',
          to: '/find-a-provider',
        },
        // Fallback when a plan slot has no `headerLogos` under variant6Cards (e.g. 4th API plan).
        variant6HeaderLogos: [
          { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
          { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
        ],
        variant6LogoCount: 2,
        // Fallback for plan slots without `yesIcon` on the card (e.g. 4th API plan).
        variant6YesIcon: YesIcon,
        variant6Cards: {
          card1: {
            logoCount: 1,
            headerLogos: [
              { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
              { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
            ],
            yesIcon: { src: YesIcon, alt: 'Included' },
          },
          card2: {
            logoCount: 2,
            headerLogos: [
              { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
              { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
            ],
            yesIcon: { src: YesIcon2, alt: 'Included' },
          },
          card3: {
            logoCount: 1,
            headerLogos: [
              { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
            ],
            yesIcon: { src: YesIcon3, alt: 'Included' },
          },
        },
      },
    },
    howItWorksSection: {
      variant: 2,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'left',
    },
    testimonialSection: {
      enable: false,
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/map-loc-icon.svg',
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 6,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
      variant6HeaderLogos: [
        { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
        { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
      ],
      variant6LogoCount: 2,
      variant6YesIcon: YesIcon,
      variant6Cards: {
        card1: {
          logoCount: 2,
          headerLogos: [
            { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
            { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
          ],
          yesIcon: { src: YesIcon, alt: 'Included' },
        },
        card2: {
          logoCount: 2,
          headerLogos: [
            { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
            { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
          ],
          yesIcon: { src: YesIcon2, alt: 'Included' },
        },
        card3: {
          logoCount: 2,
          headerLogos: [
            { src: PlanCardHeaderLogo1, alt: 'Lollipop Dental' },
            { src: PlanCardHeaderLogo2, alt: 'Lollipop Dental' },
          ],
          yesIcon: { src: YesIcon3, alt: 'Included' },
        },
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true,
    showPlanDiscHeader: true,
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: LoginLogo,
  },
  theme: Theme,
};

export default config;
